export default __webpack_public_path__ + "6f7731b02507f638f06fb9ddf6ad5596.png";